import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash, faLink, faDownload } from "@fortawesome/free-solid-svg-icons";
import { Button, Modal, ModalContent, ModalBody, ModalHeader, useDisclosure } from "@heroui/react";
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks";
import { apiRoute, GetLoginCredentialDb, linksUrl } from "../../constants/enum";
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components";
import { COLUMN_ALIGN_TYPE, ROW_ACTION_BTN_TYPE } from "../../components/NextUITable";
import { toast } from "react-toastify";
import ConfirmBox from "../../components/ConfirmBox";
import { resetDetailParams, setDetailParams, setNewEntryMode } from "../../state/clientApiSettingSlice";
// import { setNewEntryMode, setDetailParams } from "../../redux/actions"; // Uncomment if needed

const ApiKeyMaster = () => {
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const { yearId, compCode } = useSelector((state) => state.company)
  const [itemToDelete, setItemToDelete] = useState("")
  const dispatch = useDispatch();

  // Fetch API key list
  const {
    data: clientApiData = [],
    isLoading,
    isError,
  } = useFetchWithBody({
    url: apiRoute.clientApiSetting.fetch, // API endpoint for getClientApiSettings
    queryKey: "fetchClientApiSettings",

  });

  const {
    data: apiuserData = [],
  } = useFetchWithBody({
    url: apiRoute.clientApiSetting.fetchApiUser, // API endpoint for getClientApiSettings
    queryKey: "fetchApiUser",
    inputData:{
      client_code:user.clientCode
    }
    

  });

  const {
    isOpen: isOpenBoxModel,
    onOpen: onOpenBoxModel,
    onOpenChange: onOpenBoxModelChange,
  } = useDisclosure()
  const sortedData = [...clientApiData].sort((a, b) =>
    a.Client_Name.localeCompare(b.Client_Name)
  );

  const { mutate: deleteClientApi } = usePost({
    url: apiRoute.clientApiSetting.deleteEntry,
    queryKey: "deleteClientApiSetting",
    onSuccessTasks: () => {
      navigate(linksUrl.clientApiEntry.apiEntryMaster);
      toast.success("Client API deleted successfully!", { position: "top-center" });
      setItemToDelete("");

    },
  });

  const handleDeleteClick = (clientName) => {
    setItemToDelete(clientName);
  };
  const handleConfirmBox = (confirm) => {
    if (confirm && itemToDelete) {
      deleteClientApi({ data: { Client_Name: itemToDelete } });
    }
    else
      setItemToDelete("");
  };


  // const boxModel = () => {
  //   return (
  //     <div>
  //       <Modal
  //         isOpen={isOpenBoxModel}
  //         onOpenChange={onOpenBoxModelChange}
  //         size="md"
  //         scrollBehavior="inside"
  //         placement="center"
  //       >
  //         <ModalContent>
  //           {(onClose) => (
  //             <>
  //               <ModalHeader className="m-0 px-2 bg-gray-100 border-b-2 border-gray-700">
  //                 API URL
  //               </ModalHeader>
  //               <ModalBody>
  //                 {apiUrl}
  //               </ModalBody>
  //             </>
  //           )}
  //         </ModalContent>
  //       </Modal>
  //     </div>
  //   )
  // }
  const handleAddNew = () => {
    dispatch(resetDetailParams())
    navigate(linksUrl.clientApiEntry.createApiEntry);

  };
  const exportColumns = [
    { name: "Client Name", uid: "Client_Name" },
    { name: "API Key", uid: "Api_Key" },
    { name: "Markup (%)", uid: "Markup" },
  ]
  const downloadDataFooter = {
    Client_Name: "",
    Api_Key: "",
    Markup: ""
  }


  const columns = [
    { name: "Actions", uid: "actions", align: COLUMN_ALIGN_TYPE.center },
    { name: "Client Name", uid: "Client_Name", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    { name: "API Key", uid: "Api_Key", sortable: true, align: COLUMN_ALIGN_TYPE.center },
    { name: "Markup (%)", uid: "Markup", sortable: true, align: COLUMN_ALIGN_TYPE.center },
  ];

  const handleDownload = (api_key) => {
    //const db_user = GetLoginCredentialDb(user, yearId)
    const apiDetails = `
      API URL:
      https://windiam.iitsapp.in/api/stock-entry/fetchapistock

      Method:
      POST

      Headers:
      Content-Type: application/json

      Payload:
      {
        Credentials:{
          YearId:'${yearId}',
          ClientCode:'${apiuserData[0].Client_Code}',
          LoginName:'${apiuserData[0].LoginName}',
          UserKey:'${apiuserData[0].Password}'
        },
        CompCode:${compCode[0]},
        Dy:1,
        TradeOf:'P',
        API_Key:'${api_key}'
      }
    `;

    const blob = new Blob([apiDetails], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = 'api_details.txt';
    a.click();

    URL.revokeObjectURL(url); // Clean up
  };



  const rowActionBtn = [
    {
      icon: <FontAwesomeIcon color="#FFFFFF" icon={faDownload} />,
      onClick: (row) => {
        if(apiuserData && apiuserData.length>0){
        handleDownload(row.Api_Key)
        }
        else{
          toast.error("Api Credential Not Found ",{
            position:"top-center",
            className:"toast-error"
          })
        }
      },
      label: "API Details",
      type: ROW_ACTION_BTN_TYPE.button,
    },
    {
      icon: <FontAwesomeIcon icon={faEdit} style={{ color: "#379906" }} />,
      onClick: (row) => {
        dispatch(setDetailParams(row))
        dispatch(setNewEntryMode(false))
        navigate(linksUrl.clientApiEntry.createApiEntry,);
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
    {
      icon: <FontAwesomeIcon icon={faTrash} style={{ color: "#c40c18" }} />,
      onClick: (row) => {
        handleDeleteClick(row.Client_Name);
      },
      type: ROW_ACTION_BTN_TYPE.link,
    },
  ];

  if (isLoading) return <LoadingCard />;
  if (isError) return <ErrorCard />;

  return (
    <div>
      <MainContainer pageName="Stock Upload API key Setting" breadcrumbs={["Settings", "Stock Upload API Key"]}>
        <div className="text-right mb-4">
          <Button size="sm" color="primary" startContent={<FontAwesomeIcon icon={faPlus} />} onPress={handleAddNew}>
            Add New
          </Button>
        </div>
        {/* {boxModel()} */}
        <NextUITable
          INITIAL_VISIBLE_COLUMNS={["actions", "Client_Name", "Api_Key", "Markup"]}
          data={sortedData}
          columns={columns}
          rowActionBtn={rowActionBtn}
          downloadFileName="Client-API-Keys"
          exportColumns={exportColumns}
          downloadDataFooter={downloadDataFooter}
          showAdvanceFilter={false}
          id="Client_Name"
        />
      </MainContainer>

      {itemToDelete && itemToDelete != "" && <ConfirmBox handleConfirmBox={handleConfirmBox} />}
    </div>
  );
};

export default ApiKeyMaster;
